<template>
  <button :class="buttonClass" @click.stop="$emit('click')" :ref="refButtton">
    <icon :name="icon" />
  </button>
</template>

<script>
export default {
  props: {
    refButtton: {
      type: String
    },
    icon: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: String
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => {
        return (
          [
            'extra-super-small',
            'super-small',
            'extra-small',
            'small',
            'medium',
            'large'
          ].indexOf(value) !== -1
        );
      }
    },
    color: {
      type: String,
      default: 'primary',
      validator: value => {
        return (
          [
            'primary',
            'secondary',
            'tertiary',
            'danger',
            'warning',
            'success'
          ].indexOf(value) !== -1
        );
      }
    }
  },
  computed: {
    buttonClass() {
      return [
        'icon-button',
        this.size,
        this.color,
        this.active,
        this.disabled ? 'disabled-icon' : ''
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.disabled-icon {
  background: #e3e7ee !important;
  border: 1px solid #e3e7ee !important;
}
.active-icon {
  background: #eef7ff !important;
  border: 1px solid #409fff !important;
  box-shadow: none;
  stroke: #fff;
  svg {
    stroke: #409fff;
  }
}
.icon-button {
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  border-radius: 8px;
  flex-shrink: 0;
  &.large {
    width: 56px;
    height: 56px;
  }
  &.medium {
    width: 48px;
    height: 48px;
  }
  &.small {
    width: 40px;
    height: 40px;
  }
  &.extra-small {
    width: 32px;
    height: 32px;
  }
  &.super-small {
    width: 24px;
    height: 24px;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  &.extra-super-small {
    width: 16px;
    height: 16px;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  &.primary {
    background: #409fff;
    stroke: #fff;
    border: 2px solid #409fff;
    &:hover {
      background: #409fff;
      border-color: #409fff;
      stroke: #fff;
      box-shadow: 0px 6px 10px rgba(9, 131, 255, 0.5);
    }
    &:focus {
      background: #409fff;
      box-shadow: none;
      stroke: #fff;
    }
    &:active {
      border-color: #0077ef;
      background: #0077ef;
      box-shadow: none;
      stroke: #fff;
    }
    &:disabled {
      background: #e3e7ee;
      pointer-events: none;
      stroke: #8e9ebb;
    }
  }
  &.secondary {
    stroke: #38455d;
    background-color: transparent;
    &:hover {
      background: #eef7ff;
      stroke: #0077ef;
    }
    &:focus {
      background: #eef7ff;
      stroke: #0077ef;
    }
    &:active {
      background: #cfe7ff;
    }
    &:disabled {
      background: #e3e7ee;
      border-color: #e3e7ee;
      stroke: #8e9ebb;
    }
  }
  &.success {
    background: var(--green-tints-green, #29cc44);
    stroke: #fff;
  }
}
</style>
